export const dividendDocumentModalContextInitValue = {
  data: {
    operationId: undefined,
    partners: [],
    totalPartners: 0,
    selectedPartners: [],
    currentPage: 1,
    rowsPerPage: 10,
    isLoading: false,
  },
  actions: {
    handleCloseModal: () => {},
    handleChangePage: () => {},
    handleChangeRowsPerPage: () => {},
    handleSelectPartner: () => {},
    handleGenerateDocument: () => {},
  },
};
